module.exports = __webpack_public_path__ + "media/e4.0e5ed1db.mp3";